import React from "react"
import Seo from "../../components/seo"
import Layout from "../../components/layout"
import { Link } from "gatsby"
import "../../styles/pc/page/recruit/member.scss"
import "../../styles/sp/page/recruit/member.scss"

import LazyAndPreloadImage from "../../functions/lazy_and_preload_image"

export default function MemberPage() {
  return (
    <Layout>
      <Seo
        type="article"
        title="メンバー募集"
        description=""
        bobyClassName="menu15"
        path="recruit/member"
      />
      <div className="wrapper">
        {/*//////////////////////////////* ↓パンくずリスト * //////////////////////////////*/}
        <div className="breadcrumb">
          <Link to="/">Home</Link>　/　<Link to="/recruit">Recruit</Link>　/　<Link to="/recruit/member" className="current">Member</Link>
        </div>
        {/*//////////////////////////////* ↑パンくずリスト * //////////////////////////////*/}

        {/*//////////////////////////////* ↓タイトル * //////////////////////////////*/}
        {/*//////////////////////////////* ↑タイトル * //////////////////////////////*/}
        <div className="wrapper_contents">

          <div className="main_wide">

        {/*//////////////////////////////* ↓コンテンツ01 * //////////////////////////////*/}
        <div className="contents contents_wrap">
          <div className="contents_in_wide">
            <div className="padding_sp">{/* スマホのみ隙間 */}
            
            <div className="first_view">
              <div className="fv_image_wrapper">
              <LazyAndPreloadImage imgUrl={"/images/recruit/fv_img.jpeg"} alt="メンバー募集のメインビジュアル" />
              </div>
              <div className="fv_title_wrapper">
                <div className="pos_abs_box">
                  <p className="section_tag">＃採用情報</p>
                  <h2 className="fv_title">感情の連鎖をつくる仲間を<br className="sp_only"/>募集しています。</h2>
                </div>
              </div>
            </div>

            <div className="msg_section">
              <div className="bg_gray pc_only"></div>
              <div className="msg_wrapper">
                <h2 className="msg_title">「人と組織と社会のつながりを再生し、未来へつなぐ」</h2>
                <p className="msg_detail">
                  これが私たちジェイフィールが2022年1月にアップデートした新ミッションです。<br/>
                  これまで私たちは、2007年の創業時に「今の経営には感情というピースが足りない」、<br/>
                  「組織の中につながりを再生し、良い感情の連鎖を起こそう」、「仕事が面白い、職場が楽しい、会社が好きだということを子どもたちの前で堂々と語れる大人を増やそう」と呼びかけ、<br/>
                  そんな思いでつながる人たちを一貫して応援し続けてきました。<br/>
                  <br/>
                  しかし、これからの社会のあり方、企業のあり方、人の働き方を考えたとき、もっと社会、会社、<br/>人とのつながりを生み出したいと想い、対話を重ね、新たなミッションに至りました。<br/>
                  そこで、私たちはこの想いに賛同し、一緒に歩む仲間を探しています。<br/>
                  <br/>
                  一緒により良い未来をつくっていきませんか？
                </p>
              </div>
            </div>

            <div className="personal_image_section">
              <p className="section_title">＃ジェイフィールはこんな人を待っています。</p>
              <div className="personal_image_wrapper">
                <div className="img_box">
                  <LazyAndPreloadImage imgUrl={"/images/recruit/personal_image.jpeg"} alt="求める人材像のイメージ" />
                </div>
                <div className="caption_box">
                  <div className="caption_01">
                    <h4 className="caption_title green">枝葉となる部分</h4>
                    <p className="caption_detail green">
                    ・学び続ける意欲がある（成長意欲・向上心）<br/>
                    ・自己探求に関心がある<br/>
                    ・どんな仕事でも面白くでき、自ら考えてアウトプットしたい<br/>
                    ・自分の思いを、未来を探求したい<br/>
                    </p>
                  </div>
                  <div className="caption_02">
                    <h4 className="caption_title beige">幹となる部分</h4>
                    <p className="caption_detail beige">
                    ・ミッション、思い、世界観、思想への共感、共鳴
                    </p>
                  </div>
                  <div className="caption_03">
                    <h4 className="caption_title brown">根となる部分</h4>
                    <p className="caption_detail brown">
                    ・家族感、ファミリー感、仲間感
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="week_section">
              <p className="section_title">#ジェイフィールで働くメンバーの一週間</p>
              <div className="bg_gray pc_only"></div>
              <div className="week_wrapper">
                <div className="week_image_box">
                  <LazyAndPreloadImage imgUrl={"/images/recruit/week_board.png"} alt="ジェイフィールで働くメンバーの一週間のイメージ" />
                </div>
                <ul className="week_detail_list">
                  <li>*0：ジェイフィールのコミュニケーションツールとして、社外の方とはGmailを、社内のメンバーとはLINE WORKSを使用する場合が多いです。</li>
                  <li>*1：ジェイフィールでは、隔週でジェイフィール全体会議を開き、お互いの状況を把握したり、年度の方針や施策を全員で決めたりしています。</li>
                  <li>*2：社内ミーティングでは、クライアントのこと、マーケティングなど社内の企画などさまざまなことで議論や対話をします。</li>
                  <li>*3：資料作成では、コンサルティングや研修の企画書、研修のテキストを作成しています。また社内向けの会議資料なども作成しています。</li>
                  <li>*4：コロナ禍以前はリアルの研修しかありませんでしたが、今（2022年5月現在）ではほとんどがオンライン研修です。またジェイフィールでは、研修講師、コンサルティング、営業の3つの役割を1人が担います。</li>
                  <li>*5：クライアントミーティングでは、組織開発や人材育成の施策を打ち合わせします。具体的には研修を通じて組織開発を進める場合がほとんどです。</li>
                  <li>*6：パートナーは、研修に登壇する講師、社内のHP作成やマーケティング・広報施策の支援をしてくださる方など多岐にわたります。ジェイフィールはいろいろな人に支えられて活動しています。また、パートナーの幅を常に広げ続けています。研修に関わる方とは、研修の企画を打ち合わせたり、登壇に向け内容を共有します。広報・マーケティング施策を支援してくださる方とは、施策の企画や効果検証などを話し合います。</li>
                </ul>
              </div>
            </div>

            <div className="dialog_section">              
              <div className="bg_beige pc_only"></div>
              <div className="dialog_wrapper">
                <Link to="/note/s3fysl3q1bai" className="dialog_image_box">
                  <LazyAndPreloadImage imgUrl={"/images/recruit/article_thumbnail.jpeg"} alt="ダイアログのイメージ" />
                  <div className="dialog_title_wrapper">
                    <p className="small_section_title">#DIALOG</p>
                    <h4 className="article_title">ジェイフィールの新しい仲間に関して、<br className="sp_only"/>対話しました。</h4>
                    <p className="link pc_only">記事を読む</p>
                  </div>
                </Link>
              </div>
            </div>

            <div className="qa_section">
              <p className="section_title">#よくある質問</p>
              <div className="bg_gray pc_only"></div>
              <div className="qa_wrapper">
                <ul className="qa_list">
                  <li className="qa_item">
                    <div className="qa_question">
                      <span>Q</span>
                      <p>現在、どのような職種・ポジションを募集していますか？</p>
                    </div>
                    <div className="qa_answer">
                      <span>A</span>
                      <p>随時、コンサルタント職を募集しております。具体的な職務内容に関して、ご関心があれば是非お問い合わせください。</p>
                    </div>
                  </li>

                  <li className="qa_item">
                    <div className="qa_question">
                      <span>Q</span>
                      <p>未経験でも応募可能ですか？</p>
                    </div>
                    <div className="qa_answer">
                      <span>A</span>
                      <p>はい、もちろん可能です。</p>
                    </div>
                  </li>

                  <li className="qa_item">
                    <div className="qa_question">
                      <span>Q</span>
                      <p>勤務時間について教えてください。</p>
                    </div>
                    <div className="qa_answer">
                      <span>A</span>
                      <p>フレキシブルに働く時間を調整できます。</p>
                    </div>
                  </li>

                  <li className="qa_item">
                    <div className="qa_question">
                      <span>Q</span>
                      <p>フルリモートでの働き方は可能ですか？</p>
                    </div>
                    <div className="qa_answer">
                      <span>A</span>
                      <p>コロナ禍以降、オンラインでの仕事がメインです。但し、案件によってクライアント先への訪問がございます。</p>
                    </div>
                  </li>

                  <li className="qa_item">
                    <div className="qa_question">
                      <span>Q</span>
                      <p>入社後の研修、教育体系を教えて下さい。</p>
                    </div>
                    <div className="qa_answer">
                      <span>A</span>
                      <p>入社後、半年間はメンターが支援いたします。また、その他にも、オンボーディングをサポートする仕組みや体制を、メンターと一緒に考えます。また、その方のご経験や経歴に応じて、個別に設計、OJT、Off-JTの両面で成長をサポートさせていただきます。</p>
                    </div>
                  </li>

                  <li className="qa_item">
                    <div className="qa_question">
                      <span>Q</span>
                      <p>インターン制度はありますか？</p>
                    </div>
                    <div className="qa_answer">
                      <span>A</span>
                      <p>個別の事情や時期に合わせて検討します。詳しくはお問い合わせください。</p>
                    </div>
                  </li>

                </ul>
              </div>
            </div>


            <div className="requirements_section">     
              <p className="section_title">#募集要項</p>         
              <table className="requirements_table">
                <tbody>
                  <tr>
                    <th scope="col">職種</th>
                    <td scope="col">コンサルタント</td>
                  </tr>
                  <tr>
                    <th>仕事内容</th>
                    <td>組織・人事に関するコンサルティング　（それに関わる、企画・提案、営業・マーケティング、プログラムやワークショップのデザイン、クライアント管理、新商品・新サービスの開発、コミュニティ運営、他）<br/>
                      ※各メンバーの意向や位置付け、案件によって、最適な環境、仕事内容を考えていきます。
                    </td>
                  </tr>
                  <tr>
                    <th>雇用形態</th>
                    <td>正社員または契約社員（6ヶ月後に双方合意の上、正式契約）</td>
                  </tr>
                  <tr>
                    <th>勤務時間</th>
                    <td>9：00〜17：00</td>
                  </tr>
                  <tr>
                    <th>勤務地</th>
                    <td>渋谷</td>
                  </tr>
                  <tr>
                    <th>休日</th>
                    <td>完全週休2日制（土・日）、祝日、有給休暇（年末年始休暇、夏期休暇を含む）</td>
                  </tr>
                  <tr>
                    <th>給与</th>
                    <td>職種とグレードに応じて年俸契約</td>
                  </tr>
                  <tr>
                    <th>諸手当</th>
                    <td>通勤費</td>
                  </tr>
                  <tr>
                    <th>福利厚生</th>
                    <td>健康保険、雇用保険</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="apply_section">
              <p className="section_title">#応募方法</p>
              <div className="bg_gray pc_only"></div>
              <p className="apply_detail">
                まずは、以下のメールまでご連絡をください。募集要項、必要な書類、採用プロセスをご案内させていただきます。<br/><br/>
                送付先アドレス：<a href='mailto:career@j-feel.jp' target="_blank" rel="noopener noreferrer">career@j-feel.jp</a>
              </p>
            </div>

            <div className="message_section">
              <p className="message_detail">皆さまからのご応募、<br className="sp_only"/>心よりお待ちしております。</p>
            </div>

            </div>{/* padding_sp スマホのみ隙間 */}
          </div>{/* contents_in */}
        </div>{/* /contents */}
        {/*//////////////////////////////* ↑コンテンツ02 * //////////////////////////////*/}
          </div>{/* main */}
          <div className="page_title fixed">
            <div className="right_page_ttl"><span className="vertical">Recruit - </span><span className="txt">採用情報</span></div>
          </div>{/* right page_title */}
        </div>{/*wrapper_contents*/}
      </div>{/*wrapper*/}
    </Layout>
  )
}
